export enum CROP_STAGE_EVENT {
    CONFIRM = 'crop-stage-confirm',
    CANCEL = 'crop-stage-cancel',
}
